import client from "../libs/HttpClient";

class SubscribeServices {
  static addSubscribe(request) {
    return client.post("/subscribe-news", request);
  }
}
export { SubscribeServices };
